import type {
	IAuthResponse,
	IOnboardingRequestBody,
} from "@services/sdk/interfaces";
import { DeliveryProduct, Result } from "@services/sdk/models";
import type { AxiosInstance } from "axios";

import { Actioner } from "@services/actioner";
import type ErrorResponse from "@services/sdk/models/error-response";
import ErrorResponseFactory from "@services/sdk/models/error-response-factory";
import OnboardingDetails, {
	SIMTypeEnum,
} from "@services/sdk/models/onboarding-details";

export const createMRTMOnboardingAdapter = (httpClient: AxiosInstance) => ({
	async onboard(
		onboardingDetails: OnboardingDetails,
	): Promise<Result<IAuthResponse, ErrorResponse>> {
		const newOnboardingDetails = onboardingDetails;
		try {
			if (newOnboardingDetails.simType === SIMTypeEnum.ESIM) {
				newOnboardingDetails.deliveryMethod = DeliveryProduct.ConstructEmpty();
			}

			const data = OnboardingDetails.MapToRequestBody(newOnboardingDetails);

			if (newOnboardingDetails.simType === SIMTypeEnum.ESIM) {
				data.postalAddress = {
					formattedAddress: "",
				} as IOnboardingRequestBody["postalAddress"];
			}

			const requestBody: IOnboardingRequestBody = {
				...data,
				payment: {
					...data.payment,
				},
				channel: "WEB",
			};

			const response = await httpClient.post("/onboarding", requestBody, {
				timeout: 300000,
			});

			const responseData = response?.data?.data;

			if (!responseData) {
				return Result.Failure(
					ErrorResponseFactory.ErrorOnboarding(response?.data),
				);
			}

			const { token, refreshToken, accountId } = responseData;

			return Result.Success({ token, refreshToken, accountId });
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(ErrorResponseFactory.ErrorOnboarding(err));
		}
	},
});
